import { RectNodeConnectionsControls } from "./RectNodeConnectionsControls";

export function RectNodeConnectionsPanel() {
    return <RectNodeConnectionsControls />;
}
